export default {
    // 获取资源总线信息
    getResourceBusInfo(params, response) {
        window.vue.$apiAxios.get('/mqConfigInfo/getAllConfigInfo', params, response);
    },
    // 设备查询接口
    listDevicePage(params, response, host) {
        window.vue.$apiAxios.postRequestBody('/device/queryDeviceInfo', params, response, host);
    },
    // 添加设备
    saveDevice(params, response, host) {
        window.vue.$apiAxios.postRequestBody('/device/saveDevice', params, response, host);
    },

    // 批量删除设备接口
    deleteDevice(params, response) {
        window.vue.$apiAxios.postRequestBody('/device/deleteDevice', params, response);
    },
    // 分配
    addDeviceOrg(params, response) {
        window.vue.$apiAxios.postRequestBody('/device/addDeviceOrg', params, response);
    },
    // 取消设备分配
    deleteDeviceOrg(params, response) {
        window.vue.$apiAxios.postRequestBody('/device/deleteDeviceOrg', params, response);
    },
    // 设备数据导入
    importDevice(params, response) {
        window.vue.$apiAxios.postRequestBody('/device/uploadDeviceExcel', params, response);
    },
    // 设备数据导出
    exportDevice(params, responseType, response) {
        window.vue.$apiAxios.download('/device/exportDeviceExcel', params, responseType, response);
    },
    // 设备所属组织
    queryDeviceOrg(params, response) {
        window.vue.$apiAxios.get('/device/queryOrgByDeviceId', params, response);
    },
    // 设备类型
    queryDeviceInfoByType(params, response) {
        window.vue.$apiAxios.postRequestBody('/device/queryDeviceInfoByType', params, response);
    },
    // 设备扩展
    queryExtend(params, response) {
        window.vue.$apiAxios.get('/device/queryDeviceExtendByType', params, response);
    },
    // 设备扩展组标识
    queryExtendGroup(params, response) {
        window.vue.$apiAxios.get('/device/queryExtendGroupByType', params, response);
    },
    // 根据多个设备主键查询设备信息
    queryDeviceById(params, response) {
        window.vue.$apiAxios.postRequestBody('/device/queryDeviceById', params, response);
    },
    // 批量取消分配
    deleteMultiDeviceOrg(params, response) {
        window.vue.$apiAxios.postRequestBody('/device/deleteMultiDeviceOrg', params, response);
    },
    // 查询组织设备树
    queryDeviceOrgTree(params, host, response) {
        window.vue.$apiAxios.postRequestBody('/device/queryDeviceOrgTree', params, response, host);
    },
    // 组织设备树搜索
    queryDeviceOrgTreeByName(params, host, response) {
        window.vue.$apiAxios.postRequestBody('/device/queryDeviceOrgTreeByName', params, response, host);
    },
    // 查询组织树
    findTree(params, host, response) {
        window.vue.$apiAxios.postRequestBody('/OrgManagerController/findTree', params, response, host);
    },

    listAllIcon(params, response) {
        window.vue.$apiAxios.postRequestBody('/OrgManagerController/listAllIcon', params, response);
    },
    // 组织树搜索数据
    find(params, host, response) {
        window.vue.$apiAxios.postRequestBody('/OrgManagerController/find', params, response, host);
    },
    // 树形节点拖动排序
    orgSort(params, response) {
        window.vue.$apiAxios.postRequestBody('/OrgManagerController/orgSort', params, response);
    },
    // 根据传入url查询数据
    findTreeByUrl(params, response) {
        window.vue.$apiAxios.postRequestBody('/OrgManagerController/findTreeByUrl', params, response);
    }
};
